import React from 'react'
import { PrimaryButton } from '../../components/StyledButtons'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import { useTranslation } from 'react-i18next'

const CaseStudyForm = () => {
    const {t} = useTranslation()

    const language = useSelector(selectLanguage)

    return (
        <form>
            <div className='karibia-form'>
                <div className='form-group-primary'>
                    <p className='font-weight-bold'>{t('modal.default-form.first-name')} <span style={{color:"#FF3C00"}}>*</span></p>
                    <input type="text" placeholder='John' className='form-control-primary mt-10' />
                </div>
                <div className='form-group-primary'>
                    <p className='font-weight-bold'>{t('modal.default-form.last-name')} <span style={{color:"#FF3C00"}}>*</span></p>
                    <input type="text" placeholder='Carter' className='form-control-primary mt-10' />
                </div>
                <div className='form-group-primary'>
                    <p className='font-weight-bold'>Email <span style={{color:"#FF3C00"}}>*</span></p>
                    <input type="text" placeholder='example@gmail.com' className='form-control-primary mt-10' />
                </div>
                {language === "en"
                ?
                <p className='text-white'>
                    Note: By clicking the “Download” button, you agree to receive communications from Qrypto. You can unsubscribe at any time.
                </p>
                :
                <p className='text-white'>
                    Lưu ý: Bằng cách nhấp vào nút “Tải xuống”, bạn đồng ý nhận thông tin liên lạc từ Qrypto. Bạn có thể bỏ theo dõi bất cứ lúc nào.
                </p>
                }
                <div className='flex justify-center pt-30'>
                    <PrimaryButton disabled>Download Now</PrimaryButton>
                </div>
            </div>
        </form>
    )
}

export default CaseStudyForm